import $foreign from "./foreign.cjs";
var traverseArrayImpl = $foreign.traverseArrayImpl;
export { traverseArrayImpl };
